import { useParams } from 'react-router-dom'

import { Box, Grid } from '@mui/material'

import PageNotFound from 'pages/PageNotFound'

import { useQuery, usePlaybookAuth, useBrowserLanguagePreferences } from 'hooks'
import { publish } from 'modules/events'

import { PlaybookType, VideoOverlayDataType } from 'app/types'
import { VideoLoadingSkeleton, VideoPlayer } from 'components'

const PagePlaybook = () => {
    const queryParams = new URLSearchParams(location.search)

    const dark = queryParams.get('dark')

    const { playbookId } = useParams<{ playbookId?: string }>()

    const { openPreferredLanguage } = useBrowserLanguagePreferences()

    const { data, isValidating, error } = useQuery<{
        playbook: PlaybookType
        data: VideoOverlayDataType
    }>(
        `/c/v1/quickguidde?id=${playbookId}&forEmbed=true`,
        {
            method: 'GET',
        },
        {
            ...usePlaybookAuth(),
            onSuccess: data => {
                publish('videoPausedByCta', {
                    state: false,
                })
                openPreferredLanguage(data.playbook)
            },
        },
    )

    if (isValidating && dark) {
        return (
            <Box
                sx={{
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'black',
                }}
            />
        )
    }

    if (isValidating && !data) {
        return <VideoLoadingSkeleton />
    }

    if (error?.message || !data) {
        return <PageNotFound playbookId={playbookId} />
    }

    return (
        <Grid
            container
            justifyContent="center"
            sx={{ height: '100vh' }}
        >
            <Grid
                item
                sx={{
                    position: 'sticky',
                    top: 0,
                    height: '100%',
                    width: '100%',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        height: '100%',
                        width: '100%',
                        overflow: 'hidden',
                    }}
                >
                    <VideoPlayer
                        videos={[data.playbook]}
                        overlayData={data.data}
                    />
                </Box>
            </Grid>
        </Grid>
    )
}

export default PagePlaybook
